module.exports = __webpack_public_path__ + "static/media/Neptune.431cbc65.png";